import React from 'react'
import styles from './styles.module.scss'

interface OrbProps {
    // Diameter in px; everything inside scales with it
    size: number
    className?: string
}

// A small silver sphere with a slowly swirling sheen: a CSS take on the CMS's
// shader logo, without the WebGL weight. Static under reduced motion.
const Orb: React.FC<OrbProps> = ({ size, className }) => (
    <span className={`${styles.orb} ${className || ''}`} style={{ fontSize: size }} aria-hidden="true" />
)

export default Orb
